<div>
    <div class="flex p-b p-t">
        <!-- image -->
        <div class="w-6 minibasket-item-image">
            <a class="w-12"
               [ngClass]="item.isGiftcard ? 'ratio-3-2' : 'ratio-3-4'"
               [class.giftcardItemImage]="item.isGiftcard"
               [routerLink]="product.data?.url">
                <img class="rf"
                     [options]="item.isGiftcard ? {} : {fitIn: true}"
                     [image]="image">
            </a>
        </div>

        <div class="w-9 p-l">
            <div class="flex flex-justify-between">

                <div class="left w-6">
                    @if(item.isFreeGift) {
                    <p class="s2 col-56 w-12">{{'Free Gift' | translate}}</p>
                    }
                    <a class="p1"
                       [attr.sl-minibasket-item-name]="item.id"
                       [routerLink]="product?.data?.url">{{product?.data.name}}</a>

                    <!-- configurable options -->
                    @if (!item.isGiftcard) {
                    <div class="m-t-3 c1 col-11">
                        @for (option of item.configurableOptions; track trackByConfigurableCode($index, option); let
                        isLast = $last) {
                        <span>
                            {{option.code | attributeLabel}}: {{option.value | optionLabel : option.code}}
                            @if (!isLast) {
                            <span> | </span>
                            }
                        </span>
                        }
                    </div>
                    }
                </div>

                <!-- price -->
                <div class="w-4 p1 flex flex-justify-end flex-column-s">
                    @if (rowOrgPrice) {
                    <price precision='2'
                           class="block col-12 line-through price m-r-1 m-r-0-s"
                           [attr.sl-minibasket-item-orgprice]="item.id"
                           [value]="rowOrgPrice"></price>
                    }
                    <price precision='2'
                           class="block price"
                           [attr.sl-minibasket-item-price]="item.id"
                           [value]="item.isFreeGift ? item.data.rowPrice : rowPrice"
                           [useFreeLabel]="item.isFreeGift"></price>
                </div>
            </div>

            <!-- Gift card personalised message-->
            @if (item.giftCardPersonalisedMessage) {
            <p class="col-12 c1 left m-t-2"><span>{{'MESSAGE: %' |
                    translate : item.giftCardPersonalisedMessage}}</span>
            </p>
            }
            @if (!lock) {
            <div class="flex flex-middle m-t-2">
                <!-- quantity -->
                @if (!item.isGiftcard && !item.isVirtual && !item.isFree) {
                <item-qty class="item-qty p-r-3"
                          [model]="data.qty"
                          [product]="product"
                          [max]="maxQty"
                          [min]="minQty"
                          [status]="status"
                          [itemId]="item.id"
                          (qtyChange)="setQty($event, true)"></item-qty>
                }
                <!-- remove -->
                @if(item.productCanBeRemoved){
                <action class="button-inline-extra-small underline"
                        [attr.sl-minibasket-item-button-remove]="item.id"
                        (click)="remove()"
                        cy-basketRemove
                        [status]="removeStatus">
                    <span class="cursor-pointer">{{'Remove' | translate}}</span>
                </action>
                }
            </div>
            }

            <div class="w-12 flex flex-middle left flex-wrap">
                <div class="w-5 w-12-s">
                    <!-- stock info -->
                    @if (!isSalable) {
                    <p class="p-t-3 c1 col-2">{{'Out of stock' | translate}}</p>
                    }
                </div>

                <div class="w-7 w-12-s">
                    <result style="overflow-wrap: break-word;"
                            class="block p-t-3 col-2 c1"
                            [status]="removeStatus"></result>
                </div>
            </div>
        </div>
    </div>

    @if (product.isBundle && item.bundleSelection?.selection) {
    <div class="m-l-6 p-b p-l-10">
        <basket-bundle-options [product]="product"
                               [selection]="item.bundleSelection.selection">
        </basket-bundle-options>
    </div>
    }
</div>
